import { render, staticRenderFns } from "./PwpCareer.vue?vue&type=template&id=24fd8c8b&scoped=true&"
import script from "./PwpCareer.vue?vue&type=script&lang=js&"
export * from "./PwpCareer.vue?vue&type=script&lang=js&"
import style0 from "./PwpCareer.vue?vue&type=style&index=0&id=24fd8c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd8c8b",
  null
  
)

export default component.exports